import { IProfileNote } from '../../expert-profiles/models/profile-notes.model';
import { IExpert } from '../../experts/models/experts.models';

export enum MvpExpertType {
  Sms = 'sms',
  Rolodex = 'rolodex',
}
export type HonorariaOperator = 'gt' | 'gte' | 'lt' | 'lte' | 'eq';
export type MvpExpertOutreachType = 'email' | 'call' | 'sms';
export type MvpExpertProgression =
  | 'identified'
  | 'solicitation'
  | 'responded'
  | 'screening'
  | 'client portal'
  | 'scheduled'
  | 'complete'
  | 'rejected';

export interface IMvpExpertJobHistory {
  jobTitle: string;
  company: string;
  industry?: string;
  startDate: string;
  endDate?: string;
}

export interface IMvpExpertView extends Pick<
  IExpert,
  | 'rejection'
  | 'connectPhase'
  | 'opportunityEmails'
  | 'ownerConnectId'
  | 'opportunitySegmentId'
  | 'firstName'
  | 'lastName'
  | 'firstNameAlias'
  | 'lastNameAlias'
  | 'primaryEmail'
  | 'expertSourceId'
> {
  opportunityExpertId: string;
  opportunityId: string;
  profileId: string;
  mvpTypes: MvpExpertType[];
  primaryPhoneNumber?: string;
  linkedin?: string;
  honoraria?: {
    currency: string;
    quant?: number;
    qual?: number;
  };
  country?: string;
  jobHistory: IMvpExpertJobHistory[];
  expertSourceName: string;
  pinnedNotes: (IProfileNote & { opportunity_name?: string })[];
  attemptedOutreachTypes: MvpExpertOutreachType[];
}

export interface IMvpExpertViewEnriched extends IMvpExpertView {
  progression: MvpExpertProgression;
  searchString: string;
}

export interface IMvpExpertFilter {
  search: string;
  countries: string[];
  currentJobOnly: boolean;
  companies: string[];
  industries: string[];
  jobTitles: string[];
  types: MvpExpertType[];
  ownerConnectIds: string[];
  opportunitySegmentIds: string[];
  progressions: MvpExpertProgression[];
  honorariaCurrency: string | null;
  honorariaAmount: number | null;
  honorariaOperator: HonorariaOperator | null;
}
